import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Program } from './types';

interface ProgramCardProps {
  program: Program;
  index: number;
}

export default function ProgramCard({ program, index }: ProgramCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-gray-50 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
    >
      <div className="flex flex-col md:flex-row">
        <div className="md:w-2/5 relative bg-gray-100">
          <img
            src={program.image}
            alt={program.title}
            className="w-full h-full object-cover"
            style={{ 
              minHeight: '200px', 
              objectPosition: 'center',
              imageRendering: 'crisp-edges'
            }}
            loading="eager"
          />
          <div className="absolute top-4 left-4">
            <span className="px-3 py-1 bg-green-600 text-white rounded-full text-sm">
              {program.category}
            </span>
          </div>
        </div>
        <div className="md:w-3/5 p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{program.title}</h3>
          <p className="text-gray-600 mb-4">{program.description}</p>
          <div className="flex items-center justify-between">
            <div className="flex items-center text-gray-500">
              <Clock className="h-4 w-4 mr-2" />
              {program.duration}
            </div>
            <Link 
              to={program.link} 
              className="inline-flex items-center text-green-600 hover:text-green-700"
            >
              Learn more
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
}